/* eslint-disable no-param-reassign */
import React, {
    useCallback, useMemo, useContext
} from 'react';
import _ from 'lodash';
import { readViewModelValue } from '@xengage/gw-jutro-adapters-react';
import { ViewModelServiceContext, ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import classNames from 'classnames';
import { wizardProps } from '@xengage/gw-portals-wizard-react';
import { withRouter } from 'react-router-dom';
import { InputField } from '@jutro/legacy/components';
import { Icon } from '@jutro/components';
import { Link } from '@jutro/router';
import { Currency as CurrencyField } from 'gw-components-platform-react';
import styles from './CompanyContractDetailsComponent.module.scss';
import metadata from './CompanyContractDetailsComponent.metadata.json5';

function CompanyContractDetailsComponent(props) {

    const {
        data: CompanyContractDetailsVM,
        updateWizardData,
        submissionVM,
        CompanyContractDetailsPath
    } = props;
    const viewModelService = useContext(ViewModelServiceContext);


    const addCompanyContractDetails = useCallback(
        (event) => {
            if (event) {
                event.preventDefault();
            }

            CompanyContractDetailsVM.value = CompanyContractDetailsVM.value || []

            const { _xCenter, _dtoName } = CompanyContractDetailsVM;

            const CompanyContractDetailsObjVM = viewModelService.create(
                {},
                _xCenter,
                _dtoName
            );

            CompanyContractDetailsVM.pushElement(
                CompanyContractDetailsObjVM
            );
            updateWizardData(submissionVM);
        },
        [submissionVM, updateWizardData, CompanyContractDetailsVM, viewModelService]
    );


    const handleValueChange = useCallback(
        (value, path) => {
            if(path === 'proVal3' && value.amount.length > 10) {
                return
            }

            updateWizardData(submissionVM);
        },
        [submissionVM, updateWizardData]
    );


    const removeAssignmentItem = useCallback(
        (event, index) => {
            if (event) {
                event.preventDefault();
            }

            CompanyContractDetailsVM.value.splice(index, 1);
            _.set(submissionVM.value, CompanyContractDetailsPath, CompanyContractDetailsVM.value);
            updateWizardData(submissionVM);
        }, [submissionVM, updateWizardData, CompanyContractDetailsPath, CompanyContractDetailsVM?.value]
    );


    const getTableCell = useCallback(
        // eslint-disable-next-line @typescript-eslint/no-shadow, consistent-return
        (item, index, props) => {
            const { path } = props;
            
            if (path === 'cusNam1') {
                const value = item.cusNam1 ? item.cusNam1 : '';

                return (
                    <InputField
                        id={index + path}
                        className={styles.tableColumn}
                        path={path}
                        dataType="String"
                        onValueChange={(val, changedPath) => {
                            item.cusNam1 = val;
                            handleValueChange(val, changedPath, index);
                        }}
                        value={value}
                    />
                );
            }

            if (path === 'desOfCon2') {
                const value = item.desOfCon2 ? item.desOfCon2 : '';

                return (
                    <InputField
                        id={index + path}
                        className={styles.tableColumn}
                        path={path}
                        dataType="String"
                        onValueChange={(val, changedPath) => {
                            item.desOfCon2 = val;
                            handleValueChange(val, changedPath, index);
                        }}
                        value={value}
                    />
                );
            }

            if (path === 'proVal3') {
                const value = item.proVal3 ? item.proVal3 : '';

                return (
                    <CurrencyField
                        id={index + path}
                        className={styles.tableColumn}
                        path={path}
                        dataType="object"
                        onValueChange={(val, changedPath) => {
                            item.proVal3 = val;
                            handleValueChange(val, changedPath, index);
                        }}
                        value={value}
                    />
                );
            }


        }, [handleValueChange])

    const removeAssignmentTableRow = useCallback(
        (item, index) => (
            // eslint-disable-next-line jsx-a11y/anchor-is-valid
            <Link
                onClick={(e) => removeAssignmentItem(e, index, item)}
                className={classNames(styles.deleteSection, styles.deleteRow)}
            >
                <Icon icon="mi-delete" className={styles.deleteIcon} />
            </Link>
        ),
        [removeAssignmentItem]
    );

    const overrideProps = useMemo(() => ({
        '@field': {
            showOptional: false,
            showRequired: true
        },
        [`CompanyContractDetailsTable`]: {
            data: CompanyContractDetailsVM.value,
        }

    }), [CompanyContractDetailsVM?.value])

    const resolvers = {
        resolveCallbackMap: {
            addCompanyContractDetails,
            getTableCell,
            removeAssignmentTableRow
        }
    };

    const readValue = useCallback(
        (fieldId, fieldPath) => readViewModelValue(
            metadata.pageContent,
            CompanyContractDetailsVM,
            fieldId,
            fieldPath,
            overrideProps
        ),
        [CompanyContractDetailsVM, overrideProps]
    );

    return (
        <ViewModelForm
            uiProps={metadata.pageContent}
            model={CompanyContractDetailsVM}
            overrideProps={overrideProps}
            resolveValue={readValue}
            onValueChange={handleValueChange}
            callbackMap={resolvers.resolveCallbackMap}
            classNameMap={resolvers.resolveClassNameMap}
        />
    );


}

CompanyContractDetailsComponent.propTypes = wizardProps;
export default withRouter(CompanyContractDetailsComponent);
